
import { serviceBoxData } from '../homeComponent/ServiceData'


const ServiceBox = () => {
    console.log("serviceData", serviceBoxData)
    return (
        serviceBoxData.map((item,index) => {
            return (
                <div className='col-lg-4 col-md-6'>
                    <div className="ServiceBox" key={item.id} data-aos='fade-up' data-aos-delay={`${index*300}`}>
                        <span><img src={item?.imgSrc} alt='icon' /></span>
                        <h4>{item?.heading}</h4>
                        <p>{item?.content}</p>
                    </div>
                </div>
            )
        })
    )
}

export default ServiceBox;